export const brandKitTabsArticle = {
  title: 'Brand Kit Creator: Tabs & Outputs',
  slug: 'brand-kit-tabs',
  content: `Brand Kit Creator: Tabs & Outputs

Use tabs to build each brand asset.

1) Business Name
- Capture business name, tagline, industry, and description.

2) Logo Design
- Generate a logo and set primary/accent colors.

3) Email Signature
- Fill personal and company details to generate a signature.

4) Letterhead & Compliments Slip
- Customize stationery layouts for export.

5) Download Kit
- Collect the generated assets for download.
`,
};
